// @core/api/endpoints/calendar/list_calendar_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCalendarMembersResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List calendar members
 * Returns all members who have access to the calendar with their roles and notification preferences.
 */
export async function ListCalendarMembers(
  calendar_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCalendarMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/members`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.get<ListCalendarMembersResponse>(requestPath, { ...requestOptions, params });
}
